import usePageable from '@/composables/filters/usePageable';
import {ref} from 'vue';
import {FilterMatchMode} from 'primevue/api';
import LineIdFilter from '@/models/dto/filters/LineIdFilter';

export default function() {
  const pageable = usePageable();
  pageable.sortField.value = 'requestId';

  const filters = ref({
    associated: {value: null, matchMode: FilterMatchMode.EQUALS},
    stakeholder: {value: null},
    stakeholderId: {value: null, matchMode: FilterMatchMode.CONTAINS},
    spectrumService: {value: null, matchMode: FilterMatchMode.EQUALS},
    barcodeRangeId: {value: null},
    mainVenue: {
      value: [],
      matchMode: FilterMatchMode.CONTAINS
    },
    licencePeriod: {
      value: [],
      matchMode: FilterMatchMode.CONTAINS
    },
    startDate: {value: null, matchMode: FilterMatchMode.EQUALS},
    endDate: {value: null, matchMode: FilterMatchMode.EQUALS},
    tuningRangeFrom: {value: null, matchMode: FilterMatchMode.EQUALS},
    tuningRangeTo: {value: null, matchMode: FilterMatchMode.EQUALS},
    duplexHigh: {value: null, matchMode: FilterMatchMode.CONTAINS},
    duplexLow: {value: null, matchMode: FilterMatchMode.CONTAINS}
  });

  function reset(){
    filters.value.associated.value = null;
    filters.value.stakeholder.value = null;
    filters.value.stakeholderId.value = null;
    filters.value.spectrumService.value = null;
    filters.value.barcodeRangeId.value = null;
    filters.value.barcodeRangeId.matchMode = FilterMatchMode.CONTAINS;
    filters.value.mainVenue.value = [];
    filters.value.licencePeriod.value = [];
    filters.value.startDate.value = null;
    filters.value.endDate.value = null;
    filters.value.tuningRangeFrom.value = null;
    filters.value.tuningRangeTo.value = null;
    filters.value.duplexHigh.value = null;
    filters.value.duplexLow.value = null;
  }

    function getQueryParams() {
      return this.getQueryParams(0);
    }

  function getQueryParams(sizeValue) {
      return new LineIdFilter({
        pageable: (sizeValue != null && sizeValue > 0) ? pageable.getQueryParams(sizeValue) : pageable.getQueryParams(),
        associated: filters.value.associated.value,
        stakeholder: filters.value.stakeholder.value,
        stakeholderId: filters.value.stakeholderId.value,
        spectrumService: filters.value.spectrumService.value,
        barcodeRangeId: filters.value.barcodeRangeId.value,
        barcodeRangeIdMatcher: filters.value.barcodeRangeId.matchMode,
        mainVenues: filters.value.mainVenue.value,
        licencePeriods: filters.value.licencePeriod.value,
        startDate: filters.value.startDate.value,
        endDate: filters.value.endDate.value,
        tuningRangeFrom: filters.value.tuningRangeFrom.value,
        tuningRangeTo: filters.value.tuningRangeTo.value,
        duplexHigh: filters.value.duplexHigh.value,
        duplexLow: filters.value.duplexLow.value,
      });
  }

  return {
    pageable,
    filters,
    reset,
    getQueryParams,
  }
}


